import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  IconButton,
  useTheme,
  Box,
  Divider,
  Tooltip,
} from '@mui/material'
import useCustomStyles from '../../hooks/CustomStylesHook'
import Colors from '../../utils/colors.json'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
// import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import { USER_DIALOG_MODES, USER_TABS } from '../../constants/constants'
import dayjs from 'dayjs'

const styles = (theme: any) => ({
  card: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
  },
  avatar: {
    width: 50,
    height: 50,
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  info: {
    flex: 1,
    display: 'flex',
    flexWrap: 'no-wrap',
    gap: theme.spacing(2),
    padding: '15px !important',
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flex: '1 1 0',
    // minWidth: 0,
  },
  role: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  roleDropdown: {
    color: theme.customColors.button,
    fontWeight: 600,
  },
  circleDot: {
    width: '5px',
    height: '5px',
    backgroundColor: Colors.CIRCLE_DOT_COLOR,
    borderRadius: '50%',
    display: 'inline-block',
  },
})

export interface User {
  createdBy: string
  createdOn: string
  emailId: string
  firstName: string
  gender: string
  keycloakUserId: string
  lastName: string
  middleName: string
  phoneNumber: string
  profile: null
  role: string
  status: string
  updatedBy: null
  updatedOn: null
  userId: number | string
  userName: string
}

const UserInfoCard = ({
  user,
  handleDialogOpen,
  setSelectedUser,
}: {
  user: User
  handleDialogOpen: (e: any) => void
  setSelectedUser: (user: User) => void
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const handleEdit = () => {
    setSelectedUser(user)
    handleDialogOpen(USER_DIALOG_MODES?.UPDATE)
  }

  const getProfileColor = (status: string) => {
    if (status === USER_TABS?.ACTIVE) {
      return 'green'
    } else if (status === USER_TABS?.INACTIVE) {
      return 'red'
    } else {
      return 'white'
    }
  }

  return (
    <Card className={classes?.card} elevation={0}>
      <Avatar
        src={user?.profile || ''}
        alt={user?.firstName}
        className={classes?.avatar}
        sx={{
          border: `2px solid ${getProfileColor(user?.status)}`,
        }}
      />
      <CardContent className={classes?.info}>
        <Box className={classes?.field} minWidth={'200px'}>
          <Box display={'flex'} flexDirection={'column'}>
            <Typography fontSize={'17px'}>
              {user?.firstName + ' ' + user?.lastName}
            </Typography>
            <div className={classes?.field}>
              <Typography variant='body2' color='textSecondary'>
                ID
              </Typography>
              <Typography className={classes?.circleDot}></Typography>
              <Typography variant='body2'>{user?.userId}</Typography>
            </div>
          </Box>
        </Box>
        <Divider flexItem orientation='vertical' />
        <Box className={classes?.field} minWidth={'200px'}>
          <Typography variant='body2' color='textSecondary'>
            Phone No
          </Typography>
          <Typography className={classes?.circleDot}></Typography>
          <Typography variant='body2' color='primary'>
            {user?.phoneNumber}
          </Typography>
        </Box>
        <Divider flexItem orientation='vertical' />
        <Box className={classes?.field} minWidth={'200px'}>
          <Typography variant='body2' color='textSecondary'>
            Email ID
          </Typography>
          <Typography className={classes?.circleDot}></Typography>
          <Typography variant='body2' color='primary'>
            {user?.emailId}
          </Typography>
        </Box>
        <Divider flexItem orientation='vertical' />

        <Box className={classes?.field} minWidth={'200px'}>
          <Box display={'flex'} flexDirection={'column'} gap={1}>
            <div className={classes?.field}>
              <Typography variant='body2' color='textSecondary'>
                Role
              </Typography>
              <Typography className={classes?.circleDot}></Typography>
              <Typography variant='body2' className={classes?.roleDropdown}>
                {user?.role}
              </Typography>
            </div>
            <div className={classes?.field}>
              <Typography variant='body2' color='textSecondary'>
                Created On
              </Typography>
              <Typography className={classes?.circleDot}></Typography>
              <Typography variant='body2'>
                {dayjs(user?.createdOn).format('DD MMM YYYY')}
              </Typography>
            </div>
          </Box>
        </Box>
        <Divider flexItem orientation='vertical' />
        <div className={classes?.role}>
          <Tooltip title='Edit'>
            <IconButton onClick={handleEdit}>
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
          {/* <Tooltip title='Delete'>
            <IconButton>
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Tooltip> */}
        </div>
      </CardContent>
    </Card>
  )
}

export default UserInfoCard
